<template>
  <div class="container">
    <div class="back" @click="back()">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>返回</span>
    </div>
    <div class="flow">
      <div class="steps">
        <div
          :class="['steps-item', current === index + 1 ? 'current' : '', current > index + 1 ? 'complete' : '']"
          v-for="(item, index) in steps"
          :key="index"
        >
          <div class="number">
            <img v-if="current > index + 1" src="@/assets/icons/icon_c@2x.png" alt="" srcset="" />
            <span v-else>{{ index + 1 }}</span>
          </div>
          <div class="title">{{ item }}</div>
        </div>
      </div>
      <div class="content-plan">
        <MassUpload
          ref="massUpload"
          v-if="!isEditMode && current === 1"
          @uploadData="uploadData"
          @ok="setUnfinished(false)"
          @SkipDetection="SkipDetection"
        />
        <FileSet
          ref="fileSet"
          v-if="(!isEditMode && current === 2) || (isEditMode && current === 1)"
          :fileList="fileList"
          :datasetId="datasetId"
          @configReady="handleConfigReady"
        />
        <DataProcessing
          ref="dataProcessing"
          v-if="(!isEditMode && current === 3) || (isEditMode && current === 2)"
          @pushFileList="pushFileList"
          :fileList="fileList"
          :fileConfigs="fileConfigs"
          :datasetId="datasetId"
          :currentFileIndex="currentFileIndex"
          :fullApply="fullApply"
          @ok="handleOk"
        />
        <Preview
          v-if="(!isEditMode && current === 4) || (isEditMode && current === 3)"
          :fileList="processedFileList"
          @ok="setUnfinished(false)"
        />
      </div>
    </div>
    <a-button class="next" type="primary" @click="next" v-if="fileList.length > 0 || datasetId" :loading="isLoading">
      {{ current !== 4 ? (isEditMode && current === 3 ? '完成' : '下一步') : '完成' }}</a-button
    >
    <TipModal
      @ok="back(true)"
      :visible="backVisible"
      @cancel="backVisible = false"
      :desc="
        `
        <p>确定要返回？</p>
        <p class='placeholder'>返回将清空本次内容</p>`
      "
    />
  </div>
</template>

<script>
import MassUpload from './MassUpload.vue'
import FileSet from './FileSet.vue'
import DataProcessing from './DataProcessing.vue'
import Preview from './Preview.vue'
import TipModal from '@/components/tipModal/index.vue'

export default {
  name: 'CreateFlow',
  components: {
    MassUpload,
    FileSet,
    DataProcessing,
    Preview,
    TipModal
  },
  data() {
    return {
      current: 1, // 1 上传文件 2 文件设置 3 数据处理 4 结构预览
      fileList: [],
      steps: ['上传文件', '文件设置', '数据处理', '结构预览'], // 默认四步流程
      completeFileList: [],
      unfinished: true,
      processedFileList: [],
      isEditMode: false, // 新增标记是否是编辑模式
      datasetId: '',
      fileConfigs: [],
      currentFileIndex: 0,
      fullApply: false,
      isLoading: false,
      backVisible: false
    }
  },
  mounted() {
    // 获取路由参数
    this.datasetId = this.$route.query.datasetId
    console.log('this.$route.query', this.$route.query)

    // 如果有datasetId，说明是编辑模式
    if (this.datasetId) {
      this.isEditMode = true
      this.steps = ['文件设置', '数据处理', '结构预览'] // 编辑模式下只有三步
      this.current = 1 // 从文件设置开始
    }
  },
  methods: {
    // 根据文件名获取图标
    getFileIcon(fileName) {
      const fileType = fileName
        .split('.')
        .pop()
        .toLowerCase()
      const iconMap = {
        doc: require('@/assets/icons/icon_word.png'),
        docx: require('@/assets/icons/icon_word.png'),
        pdf: require('@/assets/icons/icon_pdf.png'),
        xls: require('@/assets/icons/icon_xlsx.png'),
        xlsx: require('@/assets/icons/icon_xlsx.png'),
        ppt: require('@/assets/icons/icon_ppt.png'),
        pptx: require('@/assets/icons/icon_ppt.png')
      }
      return iconMap[fileType] || require('@/assets/icons/icon_word.png')
    },

    back(flag) {
      if (!flag && this.fileList.length > 0) {
        console.log('this.isEditMode', this.isEditMode, this.current)
        if (((this.isEditMode && this.current < 2) || (!this.isEditMode && this.current < 3)) && !this.datasetId) {
          this.backVisible = true
          return
        }
      }
      if (this.datasetId) {
        this.$router.go(-1)
      } else {
        this.$router.push({
          name: 'repositoryFileDetails',
          query: {
            id: this.$route.query.id
          }
        })
      }
    },
    uploadData(data) {
      this.fileList = data
    },
    async next() {
      console.log(this.unfinished)
      console.log('编辑模式', this.isEditMode)
      if (this.isEditMode) {
        // 编辑模式下的步骤处理
        if (this.current === 3) {
          this.back(true)
          return
        } else if (this.current === 1) {
          try {
            const result = await this.$refs.fileSet.createDatasetDoc()
            if (!result) {
              return
            }
          } catch (error) {
            console.error('文件设置失败:', error)
            return
          }
        } else if (this.current === 2) {
          this.$refs.dataProcessing.pushFileList()
        }
      } else {
        // 正常模式下的步骤处理
        if (this.current === 4) {
          this.back(true)
          return
        } else if (this.current === 2) {
          try {
            const result = await this.$refs.fileSet.createDatasetDoc()
            console.log('result', result)
            if (!result) {
              return
            }
          } catch (error) {
            console.error('文件设置失败:', error)
            return
          }
        } else if (this.current === 3) {
          this.$refs.dataProcessing.pushFileList()
        } else if (this.current === 1) {
          try {
            const result = await this.$refs.massUpload.handleCheckFileName()
            if (!result) {
              return
            }
          } catch (error) {
            console.error('检查文件名失败:', error)
            return
          }
        }
      }
      this.unfinished = true
      this.current++
      console.log('current', this.current)
      if (this.isEditMode && this.current === 2) {
        this.isLoading = true
        this.$nextTick(() => {
          // 调用DataProcessing的提交方法
          this.$refs.dataProcessing.createDatasetDoc()
        })
      } else if (!this.isEditMode && this.current === 3) {
        this.isLoading = true
        this.$nextTick(() => {
          // 调用DataProcessing的提交方法
          this.$refs.dataProcessing.createDatasetDoc()
        })
      }
    },
    SkipDetection() {
      this.unfinished = true
      this.current++
    },
    setUnfinished(flag) {
      this.unfinished = flag
    },
    pushFileList(data) {
      this.processedFileList = data
    },
    handleConfigReady(config) {
      // 更新配置
      this.fileConfigs = config.fileConfigs
      this.currentFileIndex = config.currentFileIndex
      this.fullApply = config.fullApply
    },
    handleOk() {
      this.isLoading = false
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 18px 21px;
  position: relative;
  .next {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 20px;
  }
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    margin-bottom: 26px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .flow {
    .steps {
      display: flex;
      justify-content: center;
      height: 100px;
      .steps-item {
        display: flex;
        align-items: center;
        margin-right: 30px;
        font-size: 18px;
        color: #6b738c;
        margin-bottom: 30px;
        &::after {
          content: '';
          width: 57px;
          height: 1px;
          margin-left: 24px;
          background: #ededed;
        }
        &:last-child {
          margin-right: 0;
          &::after {
            display: none;
          }
        }
        .number {
          width: 30px;
          height: 30px;
          background: #edf3fb;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          margin-right: 16px;
        }
        .title {
          font-weight: bold;
        }
      }
      .current {
        .number {
          background: #ff6d00;
          color: #fff;
          font-weight: bold;
        }
        .title {
          color: #000;
          position: relative;
          &::after {
            content: '';
            width: 100%;
            height: 4px;
            background: #ff6d00;
            position: absolute;
            left: -3px;
            bottom: -14px;
            border-radius: 2px;
          }
        }
      }
      .complete {
        .title {
          color: #03b8a3;
        }
        &::after {
          background: repeating-linear-gradient(to right, #03b8a3 0, #03b8a3 5px, transparent 5px, transparent 10px);
        }
        .number {
          img {
            width: 100%;
          }
        }
      }
    }
    .content-plan {
      flex: 1;
      padding-right: 30px;
      height: calc(100vh - 320px);
      overflow-y: auto;
    }
  }
}
</style>
